import React, { useEffect, useState } from 'react';
import { AppflytePermissions } from "dpod-access-control";
import { Box } from '@mui/material';
import { getStyles } from './styles';
import { useTheme } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import { useAppContext } from '../../context/AppContext';
import { fetchAccountId, fetchDatabaseType, fetchSubscriberId, fetchSubscriptionId, getUserItemId } from '../../utils/GetAccountDetails';

function UserManagement() {
    const theme = useTheme();
    const styles = getStyles(theme);
    const { selectedOrganization } = useAppContext();

    const workspace_access_details = useSelector(state => state.all_data.workspace_access_details);
    const project_access_details = useSelector(state => state.all_data.project_access_details);

    const account_details = { user_id: null, account_id: null, subscription_id: null, subscriber_id: null }
    const [accountDetails, setAccountDetails] = useState(account_details);

    const [workspaceView, setWorkspaceView] = useState({ 'workspace_id': '', 'workspace_name': '', 'workspace_view': false })
    const [projectView, setProjectView] = useState({ 'project_id': '', 'project_name': '', 'project_view': false })
    const organizationId = selectedOrganization?.payload?.__auto_id__ || null

    const app_name = window.__ENV__.APP_NAME
    const schema_id = window.__ENV__.AMEYA_COLLECTIONS_SCHEMA_ID
    const appflyte_backend_url = window.__ENV__.APPFLYTE_BACKEND_URL
    const appflyte_authentication_url = window.__ENV__.APPFLYTE_AUTHENTICATION_URL
    const invite_web_app_url = `${window.__ENV__.AMEYA_WEB_URL}/invite-login`
    const appflyte_db_type = fetchDatabaseType()

    useEffect(() => {
        loadAccountDetails();
    }, []);

    const loadAccountDetails = async () => {
        const user_id = await getUserItemId()
        const account_id = await fetchAccountId()
        const subscriber_id = await fetchSubscriberId()
        const subscription_id = await fetchSubscriptionId()
        setAccountDetails(prevDetails => ({
            ...prevDetails,
            user_id: user_id,
            account_id: account_id,
            subscriber_id: subscriber_id,
            subscription_id: subscription_id
        }));
    };

    useEffect(() => {
        if (workspace_access_details?.workspace_view) {
            setWorkspaceView({
                ...workspaceView,
                workspace_id: workspace_access_details?.workspace_id,
                workspace_name: workspace_access_details?.workspace_name,
                workspace_view: workspace_access_details?.workspace_view ?? false
            })
        }
        if (project_access_details?.project_view) {
            setWorkspaceView({
                ...workspaceView,
                workspace_id: project_access_details?.workspace_id,
                workspace_name: project_access_details?.workspace_name,
            })
            setProjectView({
                ...workspaceView,
                project_id: project_access_details?.project_id,
                project_name: project_access_details?.project_name,
                project_view: project_access_details?.project_view ?? false
            })
        }
    }, [workspace_access_details, project_access_details])

    return (
        <div style={styles.mainContainer}>
            <Box sx={{ ...styles.cardContainer }}>
                {(organizationId && accountDetails.user_id && accountDetails.account_id &&
                    accountDetails.subscriber_id && accountDetails.subscription_id) &&
                    <AppflytePermissions
                        app_name={app_name}
                        schema_id={schema_id}
                        appflyte_backend_url={appflyte_backend_url}
                        appflyte_authentication_url={appflyte_authentication_url}
                        invite_web_app_url={invite_web_app_url}
                        appflyte_db_type={appflyte_db_type}

                        appflyte_account_id={accountDetails.account_id}
                        appflyte_subscriber_id={accountDetails.subscriber_id}
                        appflyte_subscription_id={accountDetails.subscription_id}
                        appflyte_organization_id={organizationId}
                        appflyte_user_id={accountDetails.user_id}

                        workspace_view={workspaceView.workspace_view}
                        workspace_id={workspaceView.workspace_id}
                        workspace_name={workspaceView.workspace_name}

                        project_view={projectView.project_view}
                        project_id={projectView.project_id}
                        project_name={projectView.project_name}
                    />}
            </Box>
        </div>
    )
}

export default UserManagement;